import React, { Component } from 'react';
import { Row, Label } from 'reactstrap';

import { withNamespaces } from 'react-i18next';
import { Link } from "react-router-dom";

import Cards from '../../../Components/Cards';
import { Pagination, Segment } from 'semantic-ui-react';
class QuickResult extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            activePageShipment: 0,
            totalPagesShipment: 0,
            activePagePedido: 0,
            totalPagesPedido: 0,
            activePageTransportPlan: 0,
            totalPagesTransportPlan: 0,
            activePageContainer: 0,
            totalPagesContainer: 0,
            // config: config,
            config: {
                shipment: [{
                    title: this.props.t("status"),
                    idExcel: "Status",
                    xls: true,
                    header: { link: false, hide: true, icon: false },
                    data: {
                        link: false,
                        progress: false,
                        icon: false,
                        status: false,
                        hide: true,
                    },
                    id: "null",
                    className: "hidden",
                },
                {
                    title: "",
                    xls: false,
                    first: true,
                    foot: { show: false, style: { fontSize: "12px", fontWeight: "bold" } },
                    header: { link: false, hide: true, icon: false },
                    data: { link: false, progress: false, icon: false, status: false },
                    id: "ShipmentId",
                    link: "/shipmentsDetal/",
                    className: "col-md-2 col-lg-1 col-sm-5",
                },
                // {
                //   title: this.props.t("shipment_no"),
                //   xls: true,
                //   hide: true,
                //   id: "ShipmentNumber",
                //   className: "col-md-1 col-lg-1 col-sm-6",
                // },

                // {
                //   title: "Cliente",
                //   xls: true,
                //   foot: {
                //     show: false,
                //     style: { fontSize: "12px", fontWeight: "bold", color: "green" },
                //   },
                //   data: { link: false, progress: false, icon: false, status: false },
                //   header: { link: false },
                //   id: "CustomerName",
                //   link: "/shipmentsDetal/",
                //   className: "col-md-3 col-lg-1 col-sm-6",
                // },
                {
                    title: this.props.t("shipment_no"),
                    xls: true,
                    foot: {
                        show: false,
                        style: { fontSize: "12px", fontWeight: "bold", color: "green" },
                    },
                    data: { link: false, progress: false, icon: false, status: false, custom: true },
                    header: { link: false, validateEvents: true },
                    id: "ShipmentNumber",
                    custom: (value) => (
                        <div class="mb-mail-from">
                            <center>
                                <Link
                                    className="linkDetail"
                                    to={"/shipmentsDetail/" + value.ShipmentId}
                                >
                                    {value.ShipmentNumber}
                                </Link>
                            </center>
                        </div>
                    ),
                    className: "col-md-3 col-lg-1 col-sm-6",
                },

                {
                    title: this.props.t("customer"),
                    header: { link: false },
                    xls: true,
                    icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
                    colorLogo: "#643296c2",
                    id: "CustomerName",
                    className: "col-md-3 col-lg-1 col-sm-6",
                },
                {
                    title: this.props.t("shipper"),
                    header: { link: false },
                    xls: true,
                    colorLogo: "#643296c2",
                    id: "ShipperName",
                    className: "col-md-3 col-lg-1 col-sm-6",
                },
                {
                    title: this.props.t("consignee"),
                    header: { link: false },
                    xls: true,
                    type: 7,
                    id: "ConsigneeName",
                    className: "col-md-2 col-lg-1 col-sm-1",
                },
                {
                    title: this.props.t("customer_reference"),
                    header: { link: false },
                    xls: true,
                    data: { link: false, progress: false, icon: false, status: false },
                    id: "CustomertRef",
                    className: "col-md-3 col-lg-1 col-sm-6",
                },

                {
                    title: this.props.t("container_num"),
                    header: { link: false },
                    xls: true,
                    type: 7,
                    id: "Containers",
                    className: "col-md-2 col-lg-1 col-sm-1",
                },
                {
                    title: this.props.t("origin"),
                    header: { link: false },
                    xls: true,
                    link: "/shipmentsDetal/",
                    id: "POL",
                    id2: "POLName",
                    className: "col-md-3 col-lg-1 col-sm-6",
                },
                {
                    title: this.props.t("destination"),
                    xls: true,
                    header: { link: false },
                    data: { link: false, progress: false, icon: false, status: false },
                    link: "/shipmentsDetal/",
                    id: "POD",
                    id2: "PODName",
                    className: "col-md-3 col-lg-1 col-sm-6",
                },

                // {
                //   title: "Ref. Consignatario",
                //   xls: true,
                //   type: 7,
                //   id: "ConsigneeRef",
                //   className: "col-md-2 col-lg-1 col-sm-1",
                // },
                // {
                //   title: "No Contenedor",
                //   xls: true,
                //   link: "/shipmentsDetal/",
                //   id: "RefCliente",
                //   className: "col-md-3 col-lg-1 col-sm-6",
                // },
                // {
                //   title: this.props.t("customer_references"),
                //   xls: true,
                //   data: { link: false, progress: false, icon: false, status: false },
                //   id: "CustomertRef",
                //   className: "col-md-3 col-lg-2 col-sm-6",
                // },
                {
                    title: this.props.t("etd"),
                    xls: true,
                    hide: false,
                    header: { link: false },
                    icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
                    colorLogo: "#643296c2",
                    id: "ETD",
                    className: "col-md-3 col-lg-1 col-sm-6",
                },
                {
                    title: this.props.t("eta"),
                    xls: true,
                    hide: false,
                    header: { link: false },
                    icon: "fa-2x mr-2 fas fa-arrow-alt-circle-left",
                    colorLogo: "#643296c2",
                    id: "ETA",
                    className: "col-md-3 col-lg-1 col-sm-6",
                },
                {
                    title: this.props.t("progress"),
                    xls: false,
                    header: { link: false },
                    data: { link: false, progress: true, icon: false, status: false },
                    id: "Progress",
                    className: "col-md-3 col-lg-1 col-sm-6",
                }]
            },
            dataPage: {
                Shipments: { Shipments: [] },
                Containers: { Containers: [] },
                Pedidos: { Pedidos: [] },
                TransportPlan: { TransportPlan: [] },
            }
        }
    };

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.data) this.setState({ data: nextProps.data, dataPage: nextProps.data, allData: nextProps.data }, () => { this.initPages() });
    }

    initPages = () => {
        const { dataPage } = this.state

        let pagShipment = Math.ceil(parseInt(dataPage.Shipments.Total) / 10)
        let totalShipment = dataPage.Shipments.Total



        this.setState({
            activePageShipment: 1,
            totalPagesShipment: pagShipment,
            totalShipment,



        })
    }


    setResultsByPage = (page, all) => {
        page = page - 1
        const pag = all.slice((page) * 10, (page + 1) * 10)
        return pag
    }

    changePage = (page, from) => {
        console.log("page", page)
        console.log("from", from)
        switch (from) {

            case 'embarques':
                this.setState({
                    activePageShipment: page,
                })
                break;
            default:
                break;
        }
        // this.buildPageResults(from)

    }

    // buildCards = () => {
    //     const { dataShipment } = this.state

    //     /* =====================================Shipment===================================================*/
    //     let tagsShipment = dataShipment.map((e, index) => {
    //         return (
    //             <div className="col-12" key={index}>
    //                 <CardShipment element={e} ></CardShipment>
    //             </div>
    //         )
    //     })
    //     this.setState({
    //         cardsShipment: ''
    //     }, () => this.setState({ cardsShipment: tagsShipment }))

    // }


    render() {
        let { activePageShipment, totalShipment } = this.state
        return (
            <div>

                <Row>

                    <div className="col-12">
                        <div className="col-12">
                            <br />
                            <h4>{this.props.t("shipments")}</h4>
                            <Label>{(activePageShipment * 10) > totalShipment ? totalShipment : activePageShipment * 10} {this.props.t("of")} {totalShipment} {this.props.t("results_quick")}</Label>
                        </div>
                    </div>
                    <div className="col-12">


                        {(totalShipment !== 0 ?
                            // <DataTable
                            //     showSearch={false}
                            //     showExcel={false}
                            //     labelSelected=""
                            //     data={this.state.dataPage.Shipments.Shipments}
                            //     columnsTable={this.state.config.shipment}
                            //     activePage={this.state.activePageShipment}
                            //     pages={this.state.totalPagesShipment}

                            // ></DataTable> 
                            <Segment basic
                            // className="comments_table_container"
                            >
                                <Cards

                                    cardInfon={true}
                                    activePage={this.state.activePageShipment}
                                    panel={false}
                                    resetAdvance={() => { this.resetAdvance() }}
                                    pagination={false}
                                    broswer={true}
                                    config={this.state.config.shipment}
                                    data={this.state.dataPage.Shipments.Shipments}


                                ></Cards>
                                {/* </div> */}
                                <div className="col-12">
                                    <center>
                                        <Pagination
                                            activePage={this.state.activePageShipment}
                                            ellipsisItem={null}
                                            totalPages={this.state.totalPagesShipment}
                                            onPageChange={(e, { activePage }) => {
                                                this.changePage(activePage, "embarques")
                                            }
                                            }
                                            // siblingRange={0}
                                            // size={window.innerWidth < 993 ? 'mini' : ''}
                                            // pointing
                                            // secondary
                                        />
                                    </center>
                                </div>
                            </Segment>
                            : ""
                        )}
                    </div>


                </Row>

            </div >
        );
    }
}
export default withNamespaces()(QuickResult);


